import { render, staticRenderFns } from "./CertificationForm.vue?vue&type=template&id=263d580c&scoped=true"
import script from "./CertificationForm.vue?vue&type=script&lang=js"
export * from "./CertificationForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=263d580c&prod&scoped=true&lang=css&external"
import style1 from "./CertificationForm.vue?vue&type=style&index=1&id=263d580c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d580c",
  null
  
)

export default component.exports